module.exports = __webpack_public_path__ + "media/img/android-icon-72x72-de7c84b5d77f14311692ac68dff33f6c.png";